<template>
  <div  class="app-container">
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="95px"
        size="mini">
        <div class="formItemBox">
          <el-form-item label="一级货主:" style="margin-top:7px;">
            <el-select v-model="searchFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" style="margin-top:7px;">
            <el-select v-model="searchFrom.customerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货权方:" style="margin-top:7px;">
            <el-select v-model="searchFrom.ownerCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in HQData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:" style="margin-top:7px;">
            <el-select v-model="searchFrom.productType" clearable @change="productTypeChange" placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" style="margin-top:7px;">
            <el-select v-model="searchFrom.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" style="margin-top:7px;">
            <el-select v-model="searchFrom.specification" clearable @change='specificationChange' placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:" style="margin-top:7px;">
            <el-select v-model="searchFrom.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="长度:" style="margin-top:7px;">
            <el-select v-model="searchFrom.length" clearable placeholder="请选择" :disabled = 'lengthDisabled'>
              <el-option
                v-for="(item, index) in lengthData"
                :key="index"
                :label="item.length"
                :value="item.length"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="件数:" style="margin-top:7px;">
            <el-select v-model="searchFrom.number" clearable placeholder="请选择">
              <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        </div>
        <div class="searchBtnBox" style="margin-left:4px;margin-bottom: 2px;">
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchClick" btnCode="003P01mB001" v-if="btnFlg[0]">查询
            </el-button>
            <el-button type="primary" size="mini" @click="chongZhiClick" btnCode="003P01mB002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="turnGoodsClick(false)" btnCode="003P01mB003" v-if="btnFlg[2]">转货清单
            </el-button>
            <el-button type="primary" size="mini" @click="turnGoodsClick(true)" btnCode="003M380300" v-if="btnFlg[9]">转货清单
            </el-button>
            <el-button type="primary" size="mini" @click="clearBtn" btnCode="003P01mB004" v-if="btnFlg[3]">清零
            </el-button>
            <el-button type="primary" size="mini" @click="exportClick" btnCode="003P01mB005" v-if="btnFlg[4]">导出
            </el-button>
            <el-button type="primary" size="mini" @click="daoru" btnCode="003P01mB006" v-if="btnFlg[5]">导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown" btnCode="003P01mB007" v-if="btnFlg[6]">下载模版
            </el-button>
            <el-button type="primary" size="mini" @click="daochuHZ" btnCode="003M380100" v-if="btnFlg[7]">汇总导出
            </el-button>
          </el-form-item>
           <el-form-item >
            <div style="display: flex;">
            <span style="display: flex;">
              <div>总吨数：</div>
              <div style="color:red;">{{ Number(totalAllWeight).toFixed(3) }}</div>&nbsp;&nbsp;吨
            </span>
            <span style="margin-left:20px;display: flex;">
              <div>总件数：</div>
              <div style="color:red;">{{ totalNumber }}</div>&nbsp;&nbsp;件
            </span>
            </div>
           </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%"
        style="width: 100%; margin-top: 10px" center :fit='true' @row-click="handleRowClick"
        @current-change="handleTabCurrentChange" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row :cell-style="getCellStyle">
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column width="100" label="操作" align="center" fixed>
          <template v-slot='scope'>
            <el-button type="text" @click="quXiaoYuZhuan(scope.$index, scope.row)" v-if="scope.row.isYuanZhuanFlag">取消预转
            </el-button>
            <div v-else>
              <el-button type="text" @click="PreSelect(scope.$index, scope.row)" v-if="btnFlg[8]" >预转</el-button>
              <el-button type="text" @click="PreSelect1(scope.$index, scope.row)" v-if="btnFlg[10]" >预转</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="250">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" align="center" width="250">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="250">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="150">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="root" label="单件支数" align="center" width="150" ></el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" prop="length" label="长度（m）" align="center" width="150"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="150">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
              <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="150">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
              <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" align="center"
          width="150">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.stockPoundWeight == undefined || scope.row.stockPoundWeight == '' || scope.row.stockPoundWeight == null"></span>
              <span v-else>{{Number(scope.row.stockPoundWeight).toFixed(3)}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="平均重量（吨）" align="center" width="150">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.avgWeight == undefined || scope.row.avgWeight == ''"></span>
              <span v-else>{{ Number((scope.row.avgWeight)).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[10, 20, 30, 40, 50]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 转货弹框 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="turnMark"
      @close="closeDialog" width="1300px" center>
      <div v-loading='turnLoading'>
        <div class="bigBox">

          <div>
            <el-button type="primary" @click="clearArr">清空</el-button>
            <span class="demo-input-suffix" style="padding-left:20px">
               <spna class="red" v-if="wbdhFlag">*</spna>转货外部单号：
               <el-input v-model="transferExternalNo"  style="width:200px" :maxlength="20"  size="mini"></el-input>
            </span>
            <div v-if="isNiantouXiKu&&turnMark" style="display: flex;margin-bottom:10px;">
                <div v-if="turnGoodsTableList[0].isEnable!=1">不控货</div>
                <div style="display: flex;"  v-if="turnGoodsTableList[0].isEnable==1">
                  <span style="margin-left:20px;">货权剩余：</span>
                  <div>
                    <span v-if='turnGoodsTableList[0].controlWeight == 1'><span style="color:red">{{ turnGoodsTableList[0].surplusControlWeight
                    }}</span><span> 吨</span></span>
                    <span v-if='turnGoodsTableList[0].controlPiece == 1'><span> / </span><span style="color:red">{{
                      turnGoodsTableList[0].surplusControlNumber }}</span><span> 件</span></span>
                  </div>
                </div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">合计：</span>
                  <div>
                    <span style="color:red">{{ changeAllWeight }}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{ changeAllNumber }}</span><span> 件</span>
                  </div>
                </div>

            </div>
            <div v-else>
                <p style="display:inline-block;margin-left:10px;" v-if="disShow">控货剩余量:<span class="numbers">{{ residue
                }}</span>吨 <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    转货总重量:<span class="numbers">{{ changeAllWeight }}</span>吨</span></p>
            </div>
            <el-table :data="turnGoodsTableList" ref="turnGoodsTableList" border bordersize="mini"
              style="width: 100%;margin-top:10px;" center :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row>
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column type="text" width="55" label="操作" align="center">
                <template slot-scope="scope2">
                  <el-button @click="delClick(scope2.$index, scope2.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="转货件数" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="请输入件数" @input="numContro($event, scope.row)" v-number-input.float="0"
                      maxlength="100" v-model="scope.row.changeNumber" size="mini" style="width:100px;"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="重量（吨）" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="" @input="numControB($event, scope.row)" v-number-input.float="3"
                      maxlength="100" v-model="scope.row.changeWeight" size="mini" style="width:100px;"
                      :disabled='scope.row.inWeighingMethod == 1'></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="getCustomerAvailableNumberExp" label="可转件数" align="center" width="150">
              </el-table-column>

              <el-table-column prop="productTypeName" label="货物类型" align="center" width="130"></el-table-column>
              <el-table-column prop="steelMillName" label="产地" align="center" width="230"></el-table-column>
              <el-table-column prop="specification" label="规格" width="130" align="center"></el-table-column>
              <el-table-column prop="model" label="材质" align="center" width="150"></el-table-column>
              <!-- <el-table-column prop="length" label="长度（m）" align="center" width="120"></el-table-column> -->
              <el-table-column prop="number" label="件数" align="center" width="100"></el-table-column>
              <el-table-column prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="230"></el-table-column>
              <el-table-column prop="customerName" label="二级货主" align="center" width="230"></el-table-column>
              <el-table-column prop="ownerCustomerName" label="货权方" align="center" width="230"></el-table-column>

              <!-- <el-table-column prop="stockAvailableNumber" label="库存可转件数" align="center" width="120"></el-table-column> -->
              <!-- <el-table-column prop="" label="剩余可计划件数" align="center" width="150" ></el-table-column> -->

            </el-table>
          </div>
          <!--  表格 -->
          <div style="margin:10px 0 10px 0 ;">
            <div style="color:red;">注：默认重量（吨）=单件理重（吨）*件数</div>
          </div>
        </div>
        <div style="text-align:center;margin:15px;">
          <el-button @click="changeResetForm" size='mini'>取 消</el-button>
          <el-button type="primary" @click="submitForm" size='mini' v-if="huoQuanBtnShow == false">转 货</el-button>
          <el-button type="primary" @click="huoQuanZHClick" size='mini' v-if="huoQuanBtnShow == true">货权方转货</el-button>
          <!-- <el-button type="danger" @click="zhuanHQClick" size='mini' v-else>转给货权方</el-button> -->
        </div>
      </div>
    </el-dialog>
    <!--点击上传单据按钮-->
    <div class="addMarkBox">
      <el-dialog custom-class="el-dialog--center" title="上传凭证" :close-on-click-modal="false" :visible.sync="uploadMark"
        width="40%" center>
        <div class="el-dialog--center" style="margin:15px auto;">
          <el-upload class="upload-demo" :before-remove="beforeRemove" multiple :on-exceed="handleExceed"
            action="wms-stock-server/wmsStock/tWhImg/submitImages" ref="upload" :on-change="imgPreview" :limit="3">
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
          <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" append-to-body>
            <img width="100%" v-if="dialogImageUrl" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
        <div style="margin:15px auto;" class="el-dialog--center">
          <el-button @click="uploadMark = false">取 消</el-button>
          <el-button type="primary" @click="changeIdPicture" :disabled="isDisable">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看单据 -->
    <div class="addMarkBox">
      <el-dialog title="查看凭证" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="80%" center>
        <div class="img_box" v-if="!imgFlag">
          <div>暂未上传凭证</div>
        </div>
        <div class="box1" v-else>
          <div class="leftbox img_box">
            <div v-for="(item, index) in imgData" :key="index" @click="handChange(item.url, item.urlPrimary)"
              class="imgbox">
              <div v-if="item.urlPrimary.substring(item.urlPrimary.length - 3) === 'pdf'">
                <img src="@/assets/images/pdf.jpg">
                <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i>
              </div>
              <div v-else>
                <img :src="item.url" alt />
                <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i>
              </div>
            </div>
          </div>
          <div class="rightbox">
            <div v-if="pdfFlag" class="pdfbox">
              <iframe :src="path" frameborder="0" style="width: 100%; height:100%"></iframe>
            </div>
            <div class="imgDialog" v-else>
              <img :src="path" alt />
            </div>
          </div>
        </div>
        <div style="width:80px;margin:15px auto;">
          <el-button type="primary" @click="lookQuXiao">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 移库 -->
    <el-dialog title="移库" :close-on-click-modal="false" :visible.sync="yikuVisible" width="70%" center>
      <el-table :data="yikuTableList" ref="yikuTableList" border bordersize="mini" style="width: 100%;margin-top:10px;"
        center :header-cell-style="{ background: '#F5F5F5', color: 'black' }" :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }" highlight-current-row>

        <el-table-column prop="stockAvailableNumber" label="库存可移件数" align="center" width="150"></el-table-column>
        <el-table-column prop="transferNumber" label="移库件数" align="center" width="140">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入件数" @blur="jianInput" v-number-input.float="0" maxlength="100"
                v-model="scope.row.transferNumberY" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stockWeight" label="移库理重" align="center" width="140">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="" :disabled="true" size="mini" v-model="scope.row.stockWeightY"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stockPoundWeightY" label="移库磅重" align="center" width="140">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入磅重" v-number-input.float="3" maxlength="100" v-model="scope.row.stockPoundWeightY"
                size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="250"></el-table-column>
        <el-table-column prop="customerName" label="二级货主" align="center" width="250"></el-table-column>
        <el-table-column prop="ownerCustomerName" label="货权方" align="center" width="250"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" align="center" width="150"></el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center" width="250"></el-table-column>
        <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column prop="model" label="材质" align="center" width="100"></el-table-column>
        <el-table-column prop="number" label="件数" align="center" width="150"></el-table-column>
        <el-table-column prop="allWeight" label="总重量(吨)" align="center" width="150"></el-table-column>

        <!-- <el-table-column prop="" label="转货件数"  align="center" width="150">
            <template slot-scope="scope"><div>
              <el-input  placeholder="请输入件数" @input="numContro($event,scope.row)" v-number-input.float="0" maxlength="100" v-model="scope.row.changeNumber" size="mini" style="width:100px;"></el-input>
            </div></template>
          </el-table-column>
          <el-table-column prop="" label="转货重量（吨）"  align="center" width="150">
            <template slot-scope="scope"><div>
              <el-input  placeholder="" @input="numControB($event,scope.row)" v-number-input.float="3" maxlength="100" v-model="scope.row.changeWeight" size="mini" style="width:100px;"></el-input>
            </div></template>
          </el-table-column> -->
      </el-table>

      <div slot="footer">
        <el-button @click="yikuQuXiao">取 消</el-button>
        <el-button type="primary" :loading="yikuLoading" @click="yikuOk">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 点击弹框转货按钮 -->
    <el-dialog title="转货申请" :close-on-click-modal="false" :visible.sync="shenQingVisible" width="1100px" center>
      <div>
        <el-form :model="changeFrom" :validate-on-rule-change="false" :inline="true" ref="changeFrom"
          class="demo-form-inline" label-width="140px" size="mini">
          <div class="" style="margin-left:-25px;">
            <el-form-item label="转货后一级货主:" style="margin-top:10px;">
              <el-select v-model="changeFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择"
                @change="getNewPrimaryCustomerName1(changeFrom.primaryCustomerTaxId)" style="width:230px;">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="转货后二级货主:" prop="planTempid" style="margin-top:10px;">
              <el-select v-model="changeFrom.customerTaxId" clearable filterable placeholder="请选择" style="width:230px;"
                @change="getNewSecondaryCustomerName1(changeFrom.customerTaxId)">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>

            <el-button type="primary" @click="uploadClick1" size="mini" style="margin-top:10px;" class="">上传单据
            </el-button>
            <el-button type="text" @click="seeImg()" size="" style="margin:10px 0 0 20px;" class="">查看单据</el-button>
          </div>
          <el-form-item label="请选择收费方式:" style="margin-top:10px;" v-if='feeList.length !== 0'></el-form-item>
          <div v-for="(item, k) in feeList" :key="item.id">
            <!-- feeList -->
            <el-form-item :label="item.productTypeName">
              <el-radio-group v-model="feeList[k].chargMethod" @input='radioChange(feeList[k], feeList[k].chargMethod)'>
                <el-radio label="无限期收费">无限期收费</el-radio>
                <el-radio label="限期收费">限期收费</el-radio>
                <el-radio label="免费">免费</el-radio>
              </el-radio-group>
            </el-form-item>
            <span v-if="feeList[k].chargMethod == '限期收费'">
              <el-form-item label="出库费基价："><span>{{ feeList[k].outboundFeePrice }}元/吨</span></el-form-item>
              <el-form-item label="库龄分档："><span>{{ feeList[k].stockAgeClassification }}天</span></el-form-item>
              <el-form-item label="单价递增："><span>{{ feeList[k].incrementPerLevel }}元/吨</span></el-form-item>
            </span>
            <span v-if="feeList[k].chargMethod == '无限期收费'">
              <el-form-item label="转货费单价："><span>{{ feeList[k].transferFeePrice }}元/吨</span></el-form-item>
              <el-form-item label="转入免堆期："><span>{{ feeList[k].transferFreePeriod }}天</span></el-form-item>
              <el-form-item label="超期费单价："><span>{{ feeList[k].overdueFeePrice }}元/吨</span></el-form-item>
            </span>
          </div>

        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="shenQingQuXiao">取 消</el-button>
        <el-button type="primary" :loading="shenQingLoading" @click="shenqQingOk">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 点击货权方转货按钮 -->
    <el-dialog title="转货申请" :close-on-click-modal="false" :visible.sync="huoQuanVisible" width="1100px" center>
      <div>
        <el-form :model="huoQuanFrom" :validate-on-rule-change="false" :inline="true" ref="huoQuanFrom"
          class="demo-form-inline" label-width="140px" size="mini">
          <div class="" style="margin-left:-25px;">
            <el-form-item label="转货后一级货主:" style="margin-top:10px;">
              <el-select v-model="huoQuanFrom.primaryCustomerTaxId" disabled clearable filterable placeholder="请选择"
                @change="getNewPrimaryCustomerName(changeFrom.primaryCustomerTaxId)" style="width:230px;">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="转货后二级货主:" prop="planTempid" style="margin-top:10px;">
              <el-select v-model="huoQuanFrom.customerTaxId" clearable disabled filterable placeholder="请选择"
                style="width:230px;" @change="getNewSecondaryCustomerName(changeFrom.customerTaxId)">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>

            <el-button type="primary" @click="uploadClick" size="mini" style="margin-top:10px;" class="">上传单据
            </el-button>
            <el-button type="text" @click="seeImg()" size="" style="margin:10px 0 0 20px;" class="">查看单据</el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="huoQuanQuXiao">取 消</el-button>
        <el-button type="primary" :loading="huoQuanLoading" @click="huoQuanOk">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 点击转给货权方按钮 -->
    <el-dialog title="转货申请" :close-on-click-modal="false" :visible.sync="zhuanHQVisible"
      @close="zhuanHQQuXiao('zhuanHQFrom')" width="1200px" center>
      <div>
        <el-form :model="zhuanHQFrom" :validate-on-rule-change="false" :inline="true" :rules="rules" ref="zhuanHQFrom"
          class="demo-form-inline" label-width="140px" size="mini">
          <div class="" style="margin-left:-25px;">
            <el-form-item label="转货后一级货主:" style="margin-top:10px;">
              <el-select v-model="zhuanHQFrom.primaryCustomerTaxId" disabled clearable filterable placeholder="请选择"
                @change="getNewPrimaryCustomerName(changeFrom.primaryCustomerTaxId)" style="width:230px;">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="转货后二级货主:" prop="planTempid" style="margin-top:10px;">
              <el-select v-model="zhuanHQFrom.customerTaxId" clearable disabled filterable placeholder="请选择"
                style="width:230px;" @change="getNewSecondaryCustomerName(changeFrom.customerTaxId)">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货权方:" prop="newOwnerCustomerTaxId" style="margin-top:10px;">
              <el-select v-model="zhuanHQFrom.newOwnerCustomerTaxId" clearable filterable placeholder="请选择"
                style="width:230px;" @change="getNewSecondaryCustomerName(changeFrom.customerTaxId)">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="zhuanHQQuXiao('zhuanHQFrom')">取 消</el-button>
        <el-button type="primary" :loading="zhuanHQLoading" @click="zhuanHQOk">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <daoru v-if="daoruMark" :daoruMark.sync="daoruMark"></daoru>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  findStorageFeeRules, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  getStockCustomerList, // 列表
  addEmptyChangeZy, // 转货保存
  submitImage, // 上传
  getImgShow, // 查看单据
  updateImage, // 删除单据
  clearStockCustomer, // 清零按钮
  getStockCustomerWN, // 总吨数、总件数
  deleteImage, // 删除单据
  addTransferLibrary,
  getWeighingMethodList,
  surplusControlWeight,
  getCargoControlList,
  getCusAvNuExp,
  addEmptyChangeForOwnerZy, // 货权方转货
  addEmptyChangeToOwner, // 转给货权方保存
  getCustomerAvailableNumberExp,
  virtualControlBeanZy,
  addEmptyChangeZyKh
} from '@/api/wms-stock.js'
import {
  getBtn
} from '@/utils/getButton'
import {
  emptyFn,
  formatterRowEmpty,
  sortArr
} from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  zidianKuwei,
  findCustomerList
} from '@/api/wms-access.js'
import daoru from './daoru.vue'
const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  return function () {
    let context = this
    let args = arguments

    if (timer) clearTimeout(timer)

    let callNow = !timer
    timer = setTimeout(() => {
      timer = null
    }, delay)

    if (callNow) fn.apply(context, args)
  }
}
export default {
  components: {
    daoru
  },

  data () {
    return {
      daoruMark: false,
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      typeList: [],
      feeList: [],
      btnFlg: [],
      btnIdArr: [
        '003P01mB001',
        '003P01mB002',
        '003P01mB003',
        '003P01mB004',
        '003P01mB005',
        '003P01mB006',
        '003P01mB007',
        '003M380100',
        '003M380200',
        '003M380300',
        '003M380400'
      ],
      title: '',
      h: '500px',
      BigNmuber: 0,
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 20,
        model: ''
      },
      customerData: [], // 货主数据
      HQData: [], // 货权方
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      CWData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      lengthDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      value: '',
      tableList: [],
      tabLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      turnMark: false, // 转货弹框
      turnGoodsTableList: [],
      changeFrom: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        oldOwnerCustomerName: '', // 原货权方名称
        oldOwnerCustomerTaxId: '' // 原货权方纳税人
      },
      plantNoByShipName: [],
      stockInf: [],
      turnLoading: false,
      portOptions: [], // 港口
      baoCunData: [],
      selectionData: [],
      changeNumber: '',
      changeWeight: '',
      uploadMark: false,
      dialogVisible: false,
      dialogImageUrl: '',
      arrImg: [],
      isDisable: false,
      addMarkLookBox: false, // 查看弹窗
      imgFlag: true,
      imgData: [],
      seen: true,
      seen2: true,
      seen3: false,
      imageD: '',
      pdfFlag: false,
      totalAllWeight: '0', // 总吨数
      totalNumber: '0', // 总件数
      yikuVisible: false,
      yikuLoading: false,
      yikuTableList: [],
      CangweiOptions: [],
      residue: 0,
      inWeighingMethod: 0,
      disShow: false,
      pdfVisible: false,
      path: '',
      changeAllWeight: 0,
      uploadId: '', // 上传图片的时间戳
      shenQingVisible: false,
      shenQingLoading: false,
      // 货权方
      huoQuanBtnShow: false,
      huoQuanVisible: false,
      huoQuanFrom: {
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerName: '',
        customerTaxId: '',
        ownerCustomerTaxId: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        oldOwnerCustomerName: '', // 原货权方名称
        oldOwnerCustomerTaxId: '' // 原货权方纳税人
      },
      huoQuanLoading: false,
      // 转给货权方
      zhuanHQVisible: false,
      zhuanHQFrom: {
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerName: '',
        customerTaxId: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        newOwnerCustomerName: '',
        newOwnerCustomerTaxId: ''
      },
      zhuanHQLoading: false,
      rules: {
        newOwnerCustomerTaxId: [{
          required: true,
          message: '请选择货权方',
          trigger: 'change'
        }]
      },
      isNiantouXiKu: false,
      releaseFlag: 0, // 0空，1提示 后端放行。
      changeAllNumber: 0, // 预转清单总件数,
      transferExternalNo: '', // 转货外部单号
      wbdhFlag: true// 转货外部单号是否必填 20250225改成全部必填
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/customerTwo')
    this.getSeatchData(this.searchFrom)
    this.getRelationCustomer()
    this.getVirtualBalingList()
    this.getStockCustomerWN(this.searchFrom)
    this.zidianKuweiS()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
  },
  methods: {
    // 材质是HRB500E就标称红色
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'model' && row.model == 'HRB500E') {
        return { color: 'red' }
      }
    },
    radioChange (item, value) {
      console.log(item, value, '11111111111')
      if (!item.id) {
        this.$message.error('没有维护计费规则')
        this.$set(item, 'chargMethod', '免费')
      }
    },
    // 获取转货后一级货主名称
    getNewPrimaryCustomerName1 (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newPrimaryCustomerName = item.custerName
          this.findStorageFeeRulesS()
        }
      })
      // console.log(this.changeFrom.newPrimaryCustomerName, 'this.changeFrom.newPrimaryCustomerName')
    },
    // 获取转货后二级货主名称
    getNewSecondaryCustomerName1 (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newSecondaryCustomerName = item.custerName
          this.findStorageFeeRulesS()
        }
      })
      // console.log(this.changeFrom.newSecondaryCustomerName, 'this.changeFrom.newPrimaryCustomerName')
    },
    findStorageFeeRulesS () {
      if (this.changeFrom.newPrimaryCustomerName && this.changeFrom.newSecondaryCustomerName) {
        this.typeList.forEach((item1, index1) => {
          this.$set(item1, 'primaryCustomerName', this.changeFrom.newPrimaryCustomerName)
          this.$set(item1, 'customerName', this.changeFrom.newSecondaryCustomerName)
        })
      } else {
        return
      }
      console.log(this.turnGoodsTableList, 'this.turnGoodsTableList')
      //               查询仓储费规则
      let newObj = {}
      this.typeList = this.typeList.reduce((preVal, curVal) => {
        newObj[curVal.productTypeName] ? '' : newObj[curVal.productTypeName] = preVal.push(curVal)
        return preVal
      }, [])

      findStorageFeeRules(this.typeList)
        .then(res => {
          this.feeList = res

          // 转货时需选择新货主收费方式：无限期、限期、免费选一种，默认显示无限期，
          // 如果无计费规则，选中免费，再选其他方式时给出提示“没有维护计费规则”；
          // 如果新货主没有选中，后面的收费单价不显示。
          let arr = this.typeList
          arr.forEach((item1, index1) => {
            const newArr = this.feeList.filter(num => num.productTypeName == item1.productTypeName)
            if (newArr.length > 0) {
              this.$set(item1, 'incrementPerLevel', newArr[0].incrementPerLevel)
              this.$set(item1, 'outboundFeePrice', newArr[0].outboundFeePrice)
              this.$set(item1, 'overdueFeePrice', newArr[0].overdueFeePrice)
              this.$set(item1, 'id', newArr[0].id)
              this.$set(item1, 'stockAgeClassification', newArr[0].stockAgeClassification)
              this.$set(item1, 'transferFeePrice', newArr[0].transferFeePrice)
              this.$set(item1, 'transferFreePeriod', newArr[0].transferFreePeriod)
              this.$set(item1, 'chargMethod', '无限期收费')
            } else {
              this.$set(item1, 'incrementPerLevel', '')
              this.$set(item1, 'outboundFeePrice', '')
              this.$set(item1, 'overdueFeePrice', '')
              this.$set(item1, 'stockAgeClassification', '')
              this.$set(item1, 'transferFeePrice', '')
              this.$set(item1, 'transferFreePeriod', '')
              this.$set(item1, 'chargMethod', '免费')
            }
          })
          console.log(arr, ' arr')
          this.feeList = arr
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    daoru () {
      this.daoruMark = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location =
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E5%AE%A2%E6%88%B7%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx' // 后更改页面地址
    },
    turnClick () {
      console.log(this.selectionData)
      if (this.selectionData.length == 0) {
        this.$message({
          message: '请先选择一条数据',
          type: 'error'
        })
        return
      }
      this.yikuVisible = true
      this.zidianKuweiS()
      this.yikuTableList = []
      getCusAvNuExp({
        ownerCustomerTaxId: this.selectionData.ownerCustomerTaxId,
        primaryCustomerTaxId: this.selectionData.primaryCustomerTaxId,
        customerTaxId: this.selectionData.customerTaxId,
        productType: this.selectionData.productType,
        steelMillName: this.selectionData.steelMillName,
        model: this.selectionData.model,
        specification: this.selectionData.specification,
        warehouseId: this.selectionData.warehouseId
      })
        .then(res => {
          console.log(res)
          let obj = {
            warehouseIdY: '',
            transferNumberY: '',
            stockWeightY: '',
            stockPoundWeightY: '',
            allWeightY: '',
            getCustomerAvailableNumberExp: res,
            ...this.selectionData
          }
          this.yikuTableList.push(obj)
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    yikuQuXiao () {
      this.yikuVisible = false
    },
    yikuOk () {
      if (this.yikuTableList[0].warehouseIdY == '' || this.yikuTableList[0].transferNumberY == '' || this
        .yikuTableList[0].stockPoundWeightY == '') {
        this.$message({
          message: '请先填写信息',
          type: 'error'
        })
        return
      }
      if (this.yikuTableList[0].transferNumberY > this.yikuTableList[0].stockAvailableNumber) {
        this.$message({
          message: '移库件数不能大于库存可移件数',
          type: 'error'
        })
        return
      }
      getWeighingMethodList({
        productType: this.selectionData.productType
      }).then(res => {
        console.log(res)
        if (res[0].inWeighingMethod == 1) {
          this.$set(this.yikuTableList[0], 'allWeightY', this.yikuTableList[0].stockWeightY)
        } else {
          this.$set(this.yikuTableList[0], 'allWeightY', this.yikuTableList[0].stockPoundWeightY)
        }

        console.log(this.yikuTableList)
        let obj = this.yikuTableList[0]
        this.CangweiOptions.forEach(item => {
          if (item.warehouseId == obj.warehouseIdY) {
            obj.warehouseNameY = item.warehouseName
          }
        })
        addTransferLibrary({
          stockCustomerId: obj.stockCustomerId,
          transferNumber: obj.transferNumberY,
          warehouseId: obj.warehouseIdY,
          warehouseName: obj.warehouseNameY,
          stockWeight: obj.stockWeightY,
          stockPoundWeight: obj.stockPoundWeightY,
          allWeight: obj.allWeightY
        })
          .then(res => {
            this.$message({
              message: '移库成功',
              type: 'success'
            })
            this.yikuVisible = false
            this.getSeatchData()
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    },
    jianInput () {
      this.yikuTableList[0].stockWeightY = Number(this.yikuTableList[0].transferNumberY / 1 * this.selectionData
        .singletonWeight / 1).toFixed(3)
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
        this.HQData = JSON.parse(JSON.stringify(res))
        this.HQData.unshift({
          'custerName': '无货权方',
          'taxpayerNumber': '-1'
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      this.goodsName = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      this.specificationVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      this.modelVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getStockCustomerList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          res.list.forEach(item => {
            item.changeWeight = ''
            item.changeNumber = ''
          })
          this.tableList = res.list

          console.log(res, '22213')
          console.log(this.turnGoodsTableList, '2323')
          this.turnGoodsTableList.forEach(item => {
            this.tableList.forEach((item1, index) => {
              if (!item1.isYuanZhuanFlag) {
                let a = item.stockCustomerId == item1.stockCustomerId
                item1.isYuanZhuanFlag = a
              }
            })
          })
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 总吨数、总件数
    getStockCustomerWN () {
      getStockCustomerWN(this.searchFrom)
        .then((res) => {
          this.totalAllWeight = res.totalWeight
          this.totalNumber = res.totalNumber
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
      this.getStockCustomerWN(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20
      }
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      // this.steelMillNameDisabled = true
      // this.specificationDisabled = true
      // this.modelDisabled = true
      // this.lengthDisabled = true
      this.getSeatchData(this.searchFrom)
      this.getStockCustomerWN(this.searchFrom)
      this.getVirtualBalingList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.selectionData = row
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击转货清单按钮
    turnGoodsClick (flag) {
      if (this.turnGoodsTableList.length == 0) {
        this.$message.error('请点击预转按钮')
      } else {
        // 全部必填不用判断了20250225
        // findCustomerList({ customerName: this.turnGoodsTableList[0].primaryCustomerName }).then(res => {
        //   if (res.length > 0 && res[0].showName == 1) {
        //     this.wbdhFlag = true
        //   } else {
        //     this.wbdhFlag = false
        //   }
        // })
        this.title = '转货清单'
        this.turnMark = true
        this.typeList = []
        this.turnLoading = false
        this.isNiantouXiKu = flag
        this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0)
          .toFixed(3)

        this.turnGoodsTableList.forEach((item, index) => {
          let form = {}

          form.primaryCustomerName = item.primaryCustomerName
          form.customerName = item.customerName
          form.productTypeName = item.productTypeName
          this.typeList.push(form)
        })
        console.log(this.typeList, 'this.typeList')
        // 获取货物计重方式
        getWeighingMethodList({
          productType: this.selectionData.productType
        })
          .then(res => {
            console.log(res)
            if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
    },
    // 删除单据
    deleteImage () {
      deleteImage({
        businessIds: this.uploadId, // 业务表id
        businessType: 'empty_stock_summary'
      }).then((res) => {
        console.log(res)
      }).catch((err) => {
        console.log(err.message)
      })
    },
    numContro (value, row) {
      this.BigNmuber = 0

      let val = (value && value.split('')) || []
      if (val != 0) {
        console.log(row, 'value')
        row.changeNumber = val.join('').match(/^\d*(\.?\d{0,1})/g)[0] || null
        this.changeNumber = row.changeNumber
        row.changeWeight = (row.singletonWeight * this.changeNumber).toFixed(3)
        this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0)
          .toFixed(3)
        this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
          .toFixed(0)
        if (row.changeNumber > row.getCustomerAvailableNumberExp) {
          DonMessage.error('转货件数不能大于库存可转件数')
          this.BigNmuber = 1
        }
      } else {
        row.changeNumber = ''
        row.changeWeight = ''
        this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0)
          .toFixed(3)
        this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
          .toFixed(0)
      }
    },
    numControB (value, row) {
      let val = (value && value.split('')) || []
      row.changeWeight = val.join('').match(/^\d*(\.?\d{0,3})/g)[0] || null
      console.log(row.changeWeight, 'row.changeWeight')
      this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0).toFixed(
        3)
    },
    // 获取转货后一级货主名称
    getNewPrimaryCustomerName (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newPrimaryCustomerName = item.custerName
        }
      })
      // console.log(this.changeFrom.newPrimaryCustomerName, 'this.changeFrom.newPrimaryCustomerName')
    },

    // 获取转货后二级货主名称
    getNewSecondaryCustomerName (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newSecondaryCustomerName = item.custerName
        }
      })
      // console.log(this.changeFrom.newSecondaryCustomerName, 'this.changeFrom.newPrimaryCustomerName')
    },
    // 点击货权方转货
    huoQuanZHClick () {
      if (this.turnGoodsTableList.length == 0) {
        DonMessage.error('请点击预转添加转货清单')
      } else {
        // 对多项转货进行校验，转货件数不能为空，转货件数不能超过库存可转件数 1为转货件数为空，2为转货件数大于库存可转件数
        let finished = 0
        this.turnGoodsTableList.forEach(item => {
          if (item.changeNumber == undefined || item.changeNumber == null || item.changeNumber == '') {
            finished = 1
          } else if (item.changeNumber > item.stockAvailableNumber) {
            finished = 2
          }
        })
        if (finished == 1) {
          this.$message.error('请输入转货件数')
          return
        } else if (finished == 2) {
          this.$message({
            message: '转货件数不能大于库存可转件数',
            type: 'error'
          })
          return
        }
        // 货权方不控货
        // 转货件数大于库存可转件数
        if (this.BigNmuber == 1) {
          this.$message.error('转货件数不能大于库存可转件数')
        } else {
          // 对于控货类型的，需要进行计算，转货总重量不能大于控货剩余量
          if (this.disShow && this.changeAllWeight > this.residue) {
            this.$message.error('')
          } else {
            this.huoQuanVisible = true
          }
        }

        this.huoQuanFrom.primaryCustomerTaxId = this.turnGoodsTableList[0].primaryCustomerTaxId
        this.huoQuanFrom.customerTaxId = this.turnGoodsTableList[0].customerTaxId
        this.huoQuanFrom.primaryCustomerName = this.turnGoodsTableList[0].primaryCustomerName
        this.huoQuanFrom.customerName = this.turnGoodsTableList[0].customerName
        this.huoQuanFrom.ownerCustomerTaxId = this.turnGoodsTableList[0].ownerCustomerTaxId
        this.uploadId = new Date().getTime()
        console.log(this.uploadId, 'this.uploadId')
      }
    },
    // 点击货权方转货取消按钮
    huoQuanQuXiao () {
      this.huoQuanVisible = false
      this.huoQuanFrom.primaryCustomerTaxId = ''
      this.huoQuanFrom.customerTaxId = ''
      this.huoQuanFrom.primaryCustomerName = ''
      this.huoQuanFrom.customerName = ''
      this.huoQuanFrom.ownerCustomerTaxId = ''
    },
    // 点击转货按钮
    submitForm () {
      if (this.turnGoodsTableList.length == 0) {
        DonMessage.error('请点击预转添加转货清单')
      } else {
        // 对多项转货进行校验，转货件数不能为空，转货件数不能超过库存可转件数 1为转货件数为空，2为转货件数大于库存可转件数
        let finished = 0
        this.turnGoodsTableList.forEach(item => {
          if (item.changeNumber == undefined || item.changeNumber == null || item.changeNumber == '') {
            finished = 1
          } else if (item.changeNumber > item.stockAvailableNumber) {
            finished = 2
          }
        })
        if (!this.transferExternalNo) {
          this.$message.error('请输入转货外部单号')
          return
        }
        if (finished == 1) {
          this.$message.error('请输入转货件数')
          return
        } else if (finished == 2) {
          this.$message({
            message: '转货件数不能大于库存可转件数',
            type: 'error'
          })
          return
        }
        // 对于控货类型的，需要进行计算，转货总重量不能大于控货剩余量
        // if (this.disShow && this.changeAllWeight > this.residue) {
        //   this.$message.error('转货总重量不能大于控货剩余量')
        // }
        // this.shenQingVisible = true
        // this.changeAllWeight = Number(this.changeAllWeight).toFixed(3)
        // 转货件数大于库存可转件数
        if (this.BigNmuber == 1) {
          this.$message.error('转货件数不能大于库存可转件数')
        } else {
          // 对于控货类型的，需要进行计算，转货总重量不能大于控货剩余量
          if (this.disShow && this.changeAllWeight > this.residue) {
            this.$message.error('转货总重量不能大于控货剩余量')
          } else {
            this.shenQingVisible = true
            this.feeList = []
            this.changeFrom.primaryCustomerTaxId = ''
            this.changeFrom.customerTaxId = ''
            this.changeFrom.customerName = ''
            this.changeFrom.primaryCustomerName = ''
            this.changeFrom.newPrimaryCustomerName = ''
            this.changeFrom.newSecondaryCustomerName = ''
          }
        }
        this.uploadId = new Date().getTime()
        console.log(this.uploadId, 'this.uploadId')
      }
    },
    // 点击转货取消
    changeResetForm () {
      this.turnMark = false
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
    },
    // 转货弹框X关闭
    closeDialog () {
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
    },
    // 点击上传凭证
    uploadClick1 () {
      if (this.changeFrom.primaryCustomerTaxId == undefined || this.changeFrom.primaryCustomerTaxId == null || this
        .changeFrom.primaryCustomerTaxId == '') {
        this.$message.error('请选择转货后一级货主')
        return
      }
      if (this.changeFrom.customerTaxId == undefined || this.changeFrom.customerTaxId == null || this
        .changeFrom.customerTaxId == '') {
        this.$message.error('请选择转货后二级货主')
        return
      }

      if (this.changeFrom.primaryCustomerTaxId == this.turnGoodsTableList[0].primaryCustomerTaxId && this.changeFrom.customerTaxId == this.turnGoodsTableList[0].customerTaxId) {
        this.$message.error('转货后一二级货主不能与转货前一二级货主相同')
        return
      }
      this.uploadMark = true
    },
    // 点击上传凭证
    uploadClick () {
      this.uploadMark = true
    },
    // 弹窗内删除图片 图片上传-删除
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    // 处理图片
    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp|.pdf)$/
      if (regex.test(fileName.toLowerCase())) {
        this.arrImg = fileList
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图')
        return false
      }
    },
    // 点击确认-上传凭证
    changeIdPicture () {
      this.isDisable = true
      if (this.arrImg.length == 0) {
        DonMessage.error('请选择需要上传的图片!')
      } else {
        let imgfile = new FormData()
        for (var i = 0; i < this.arrImg.length; i++) {
          imgfile.append('files', this.arrImg[i].raw)
        }
        let numId = {
          id: this.uploadId,
          businessType: 'empty_stock_summary'
        }
        imgfile.append('params', JSON.stringify(numId))
        submitImage(imgfile)
          .then(res => {
            DonMessage.success('操作成功!')
            this.uploadMark = false
            this.$refs.upload.clearFiles()
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 5000)
    },
    // 清零
    clearBtn () {
      if (this.selectionData.stockCustomerId == undefined) {
        this.$message.error('请选择一条数据进行操作')
      } else if (this.selectionData.number != '0') {
        DonMessage.error('您所选的数据存在件数不为0')
      } else {
        this.$confirm('清零后数据不可恢复，确定清零吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          clearStockCustomer({
            stockCustomerId: this.selectionData.stockCustomerId // 主键id
          }).then((res) => {
            this.$message.success('清零成功')
            this.getSeatchData(this.searchFrom)
          }).catch((err) => {
            this.$message.error(err.message)
          })
        }).catch(() => { })
      }
    },
    // 查看单据
    seeImg () {
      this.addMarkLookBox = true
      this.getImgShowB()
    },
    getImgShowB () {
      let params = {
        businessId: this.uploadId,
        businessType: 'empty_stock_summary'
      }
      getImgShow(params)
        .then(res => {
          this.imgData = []
          this.imgFlag = true
          if (res.length < 1) {
            this.imgFlag = false
            return
          }
          this.imgData = res
          // this.pdfFlag = false
          this.seen3 = false
          this.seen2 = true
          if (this.imgData[0].urlPrimary.substring(this.imgData[0].urlPrimary.length - 3) === 'pdf') {
            this.pdfFlag = true
          } else {
            this.pdfFlag = false
          }
          this.path = this.imgData[0].url
          // this.imgData.forEach((item, index) => {
          //   if (item.url.indexOf('pdf') !== -1) {
          //     this.pdfVisible=true
          //     this.pdfFlag = true
          //     this.seen3 = true
          //     this.seen2 = false
          //   } else {
          //     this.pdfFlag = false
          //     this.seen3 = false
          //     this.seen2 = true
          //   }
          //   if (this.pdfFlag == true) {
          //     this.path=item.url
          //   }
          // })

          // if (this.pdfFlag == true) {
          // } else {
          //   this.addMarkLookBox = true
          // }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 查看凭证-取消
    lookQuXiao () {
      this.addMarkLookBox = false
    },
    // 查看凭证-放大
    handChange (url, urlPrimary) {
      console.log(url, 2)
      this.path = url
      let str = urlPrimary.substring(urlPrimary.length - 3)
      if (str === 'pdf') {
        this.pdfFlag = true
      } else {
        this.pdfFlag = false
      }
      console.log(str)
      // this.dialogVisible = true
    },
    // 删除凭证
    delImg (item) {
      this.$confirm('确定删除文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          updateImage({
            imgId: item.imgId // 变更图片表id
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getImgShowB()
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => { })
    },
    // 导出
    daochuHZ () {
      if (this.searchFrom.primaryCustomerTaxId !== '' && this.searchFrom.primaryCustomerTaxId !== undefined) {
        exportExcel(
          this.global.wmsStockName + '/stockThreadExp/exportSummaryCustomerList',
          this.searchFrom,
          '客户库存汇总信息表'
        )
      } else {
        DonMessage.error('请先选择一级货主!')
      }
    },
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/stockThreadExp/exportStockCustomerExpList',
        this.searchFrom,
        '客户库存信息表'
      )
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.CangweiOptions = res
          this.CWData = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    surplusControlWeights (primaryCustomerTaxId, customerTaxId) {
      getCargoControlList({
        primaryCustomerTaxId: primaryCustomerTaxId,
        secondaryCustomerId: customerTaxId
      })
        .then(res => {
          console.log(res)
          if (res.length > 0) {
            this.disShow = true

            surplusControlWeight({
              oneCustomerTaxId: primaryCustomerTaxId,
              twoCustomerTaxId: customerTaxId,
              organizationId: window.localStorage.getItem('tenantCode')
            })
              .then(res => {
                console.log(res)
                this.residue = res
              })
          } else {
            this.disShow = false
          }
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    getCustomerAvailableNumberExps (obj, row) {
      getCustomerAvailableNumberExp({
        primaryCustomerTaxId: obj.primaryCustomerTaxId,
        customerTaxId: obj.customerTaxId,
        productType: obj.productType,
        steelMillName: obj.steelMillName,
        model: obj.model,
        specification: obj.specification
      })
        .then(res => {
          console.log(res)
          row.customerAvailableNumber = res
          // return res
          // this.detailsDataCopyAdd[0].customerAvailableNumber = res
          // this.$set(this.detailsDataCopyAdd[0], 'customerAvailableNumber', res)
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    async PreSelect (index, row) {
      let hadselect = false
      this.turnGoodsTableList.forEach(item => {
        console.log(item, 'item')
        if (item.stockCustomerId == row.stockCustomerId) {
          hadselect = true
        }
      })
      if (this.turnGoodsTableList.length > 0 && (row.primaryCustomerTaxId != this.turnGoodsTableList[0]
        .primaryCustomerTaxId || row.customerTaxId != this.turnGoodsTableList[0].customerTaxId || row
        .ownerCustomerTaxId != this.turnGoodsTableList[0].ownerCustomerTaxId)) {
        this.$message({
          message: '一级货主二级货主货权方必须相同',
          type: 'error'
        })
        return
      } else if (hadselect) {
        this.$message({
          message: '不可重复选择',
          type: 'error'
        })
        return
      }
      await this.getCustomerAvailableNumberExps({
        primaryCustomerTaxId: row.primaryCustomerTaxId,
        customerTaxId: row.customerTaxId,
        productType: row.productType,
        steelMillName: row.steelMillName,
        model: row.model,
        specification: row.specification
      }, row)
      console.log(row, 'row')
      getCusAvNuExp({
        primaryCustomerTaxId: row.primaryCustomerTaxId,
        ownerCustomerTaxId: row.ownerCustomerTaxId,
        customerTaxId: row.customerTaxId,
        productType: row.productType,
        steelMillName: row.steelMillName,
        model: row.model,
        specification: row.specification,
        warehouseId: row.warehouseId
      })
        .then(res => {
          row.getCustomerAvailableNumberExp = res
          console.log(row)
          row.warehouseIdY = ''
          row.transferNumberY = ''
          row.stockWeightY = ''
          row.stockPoundWeightY = ''
          row.allWeightY = ''
          row.changeWeight = ''
          row.changeNumber = ''
          getWeighingMethodList({
            productType: row.productType
          })
            .then(res => {
              console.log(this.turnGoodsTableList, 'this.turnGoodsTableList[0].ownerCustomerTaxId')
              if (res.length > 0) row.inWeighingMethod = res[0].inWeighingMethod
              this.turnGoodsTableList.push(row)
              if (this.turnGoodsTableList[0].ownerCustomerTaxId == '') {
                this.huoQuanBtnShow = false
              } else {
                this.huoQuanBtnShow = true
                this.disShow = false
              }
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
          row.isYuanZhuanFlag = true
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
      this.surplusControlWeights(row.primaryCustomerTaxId, row.customerTaxId)
    },

    PreSelect1: Debounce(function (index, row) {
      let hadselect = false
      this.turnGoodsTableList.forEach(item => {
        if (item.stockCustomerId == row.stockCustomerId) {
          hadselect = true
        }
      })
      if (this.turnGoodsTableList.length > 0 && (row.primaryCustomerTaxId != this.turnGoodsTableList[0]
        .primaryCustomerTaxId || row.customerTaxId != this.turnGoodsTableList[0].customerTaxId)) {
        this.$message({
          message: '一级货主二级货主必须相同',
          type: 'error'
        })
      } else if (hadselect) {
        this.$message({
          message: '不可重复选择',
          type: 'error'
        })
      } else {
        virtualControlBeanZy({
          oneCustomerTaxId: row.primaryCustomerTaxId,
          twoCustomerTaxId: row.customerTaxId,
          organizationId: window.localStorage.getItem('tenantCode'),
          productionPlaceName: row.steelMillName,
          specificationName: row.specification,
          materialName: row.model,
          goodTypeName: row.productTypeName
        })
          .then(res => {
            console.log(res)
            let jsonRes = JSON.parse(res)
            console.log(jsonRes)
            row.isEnable = jsonRes.isEnable
            row.controlPiece = jsonRes.controlPiece
            row.controlWeight = jsonRes.controlWeight
            row.surplusControlWeight = jsonRes.surplusControlWeight ? jsonRes.surplusControlWeight : 0
            row.surplusControlNumber = jsonRes.surplusControlNumber ? jsonRes.surplusControlNumber : 0
            row.strictReminder = jsonRes.strictReminder
            getCusAvNuExp({
              primaryCustomerTaxId: row.primaryCustomerTaxId,
              ownerCustomerTaxId: row.ownerCustomerTaxId,
              customerTaxId: row.customerTaxId,
              productType: row.productType,
              steelMillName: row.steelMillName,
              model: row.model,
              specification: row.specification,
              warehouseId: row.warehouseId
            }).then(res => {
              row.getCustomerAvailableNumberExp = res
            })
            if (this.turnGoodsTableList.length == 0) {
              this.$set(row, 'changeNumber', '')
              this.$set(row, 'changeWeight', '')
              this.$set(row, 'isYuanZhuanFlag', true)
              getWeighingMethodList({
                productType: row.productType
              })
                .then(res => {
                  console.log(res)
                  if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                  row.RowStr = row.isEnable == 2 ? '不控货'
                    : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` ==
                          '' ? '总控'
                      : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
                  this.turnGoodsTableList.push(row)
                })
                .catch(err => {
                  this.$message({
                    message: err.message,
                    type: 'error'
                  })
                })
            } else {
              console.log(res)
              let Str =
                `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
              // let RowStr = `${this.turnGoodsTableList[0].steelMillName ? this.turnGoodsTableList[0].steelMillName : ''}${this.turnGoodsTableList[0].productTypeName ? this.turnGoodsTableList[0].productTypeName : ''}${this.turnGoodsTableList[0].specification ? this.turnGoodsTableList[0].specification : ''}${this.turnGoodsTableList[0].model ? this.turnGoodsTableList[0].model : ''}`
              console.log(this.turnGoodsTableList[0].RowStr, Str)
              if (this.turnGoodsTableList[0].isEnable == jsonRes.isEnable) {
                if ((this.turnGoodsTableList[0].isEnable == 1 && Str == this.turnGoodsTableList[0].RowStr) ||
                  this.turnGoodsTableList[0].isEnable == 2) {
                  this.$set(row, 'changeNumber', '')
                  this.$set(row, 'changeWeight', '')
                  this.$set(row, 'isYuanZhuanFlag', true)
                  getWeighingMethodList({
                    productType: row.productType
                  })
                    .then(res => {
                      console.log(res)
                      if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                      row.RowStr = row.isEnable == 2 ? '不控货'
                        : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` ==
                              '' ? '总控'
                          : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`

                      this.turnGoodsTableList.push(row)
                    })
                    .catch(err => {
                      this.$message({
                        message: err.message,
                        type: 'error'
                      })
                    })
                } else {
                  this.$message({
                    message: '控货类型不同，不可选择',
                    type: 'error'
                  })
                }
              } else {
                this.$message({
                  message: '控货类型不同，不可选择',
                  type: 'error'
                })
              }
            }
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }

      // this.surplusControlWeights(row.primaryCustomerTaxId, row.customerTaxId)
    }),
    isYuZhuanShow (row) {
      this.turnGoodsTableList.forEach((item1, index) => {
        console.log(row.stockCustomerId, 'row.stockCustomerId')
        console.log(item1.stockCustomerId, 'item1.stockCustomerId')
        let a = row.stockCustomerId == item1.stockCustomerId
        // console.log(a, '11111111111')
        row.isYuanZhuanFlag = a
      })
    },
    quXiaoYuZhuan (index, row) {
      console.log(index, row)
      row.isYuanZhuanFlag = false
      for (let a = 0; a < this.turnGoodsTableList.length; a++) {
        if (this.turnGoodsTableList[a].stockCustomerId == row.stockCustomerId) {
          this.turnGoodsTableList.splice(a, 1)
        }
      }
    },
    clearArr () {
      this.turnGoodsTableList = []
      this.changeAllWeight = 0
      this.tableList.map(function (item) {
        item.isYuanZhuanFlag = false
      })
    },
    delClick (index, row) {
      this.turnGoodsTableList.splice(index, 1)
      if (this.turnGoodsTableList.length == 0) {
        this.tableList.map(function (item) {
          item.isYuanZhuanFlag = false
        })
      } else {
        this.isYuZhuanShow(row)
      }

      this.changeAllWeight = Number(this.changeAllWeight / 1 - row.changeWeight / 1).toFixed(3)
    },
    shenQingQuXiao () {
      this.shenQingVisible = false
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
    },
    shenqQingOk () {
      if (this.changeFrom.primaryCustomerTaxId == undefined || this.changeFrom.primaryCustomerTaxId == null || this
        .changeFrom.primaryCustomerTaxId == '') {
        this.$message.error('请选择转货后一级货主')
      } else if (this.changeFrom.customerTaxId == undefined || this.changeFrom.customerTaxId == null || this
        .changeFrom.customerTaxId == '') {
        this.$message.error('请选择转货后二级货主')
      } else {
        if (this.changeFrom.primaryCustomerTaxId == this.turnGoodsTableList[0].primaryCustomerTaxId && this.changeFrom.customerTaxId == this.turnGoodsTableList[0].customerTaxId) {
          this.$message.error('转货后一二级货主不能与转货前一二级货主相同')
          return
        }
        this.shenQingLoading = true
        this.turnGoodsTableList.forEach((item1, index1) => {
          const newArr = this.feeList.filter(num => num.productTypeName == item1.productTypeName)
          console.log(newArr, 'newArr')
          if (newArr.length !== 0) {
            this.$set(item1, 'incrementPerLevel', newArr[0].incrementPerLevel)
            this.$set(item1, 'outboundFeePrice', newArr[0].outboundFeePrice)
            this.$set(item1, 'overdueFeePrice', newArr[0].overdueFeePrice)
            this.$set(item1, 'id', newArr[0].id)
            this.$set(item1, 'stockAgeClassification', newArr[0].stockAgeClassification)
            this.$set(item1, 'transferFeePrice', newArr[0].transferFeePrice)
            this.$set(item1, 'transferFreePeriod', newArr[0].transferFreePeriod)
            this.$set(item1, 'chargMethod', newArr[0].chargMethod)
          } else {
            this.$set(item1, 'incrementPerLevel', '')
            this.$set(item1, 'outboundFeePrice', '')
            this.$set(item1, 'overdueFeePrice', '')
            this.$set(item1, 'stockAgeClassification', '')
            this.$set(item1, 'transferFeePrice', '')
            this.$set(item1, 'transferFreePeriod', '')
            this.$set(item1, 'chargMethod', '免费')
          }
        })
        this.turnGoodsTableList.forEach(item => {
          if (item.chargMethod == '无限期收费') {
            this.$set(item, 'outboundFeePrice', '')
            this.$set(item, 'stockAgeClassification', '')
            this.$set(item, 'incrementPerLevel', '')
          } else if (item.chargMethod == '限期收费') {
            this.$set(item, 'transferFeePrice', '')
            this.$set(item, 'transferFreePeriod', '')
            this.$set(item, 'overdueFeePrice', '')
          } else {
            this.$set(item, 'outboundFeePrice', '')
            this.$set(item, 'stockAgeClassification', '')
            this.$set(item, 'incrementPerLevel', '')
            this.$set(item, 'transferFeePrice', '')
            this.$set(item, 'transferFreePeriod', '')
            this.$set(item, 'overdueFeePrice', '')
          }
        })
        // return
        if (this.isNiantouXiKu) { // 念头西库转货走这个逻辑  20240204
          if (this.turnGoodsTableList[0].isEnable == '1') {
            // 严控
            if (this.turnGoodsTableList[0].strictReminder == '0') {
              // 控件
              if (this.turnGoodsTableList[0].controlPiece == '1') {
                if (this.changeAllNumber > this.turnGoodsTableList[0].surplusControlNumber) {
                  this.$message.error('输入的件数不能大于货权量')
                  this.shenQingLoading = false
                  return
                }
              }
              if (this.turnGoodsTableList[0].controlWeight == '1') { // 控吨
                if (this.changeAllWeight > this.turnGoodsTableList[0].surplusControlWeight) {
                  this.$message.error('输入的重量不能大于货权量')
                  this.shenQingLoading = false
                  return
                }
              }
              this.NiantouXiKuZHjiekou()
            } else {
              console.log('提示')
              // 提示
              if (this.turnGoodsTableList[0].controlPiece == '1') {
                if (this.changeAllNumber > this.turnGoodsTableList[0].surplusControlNumber) {
                  this.$message.error('所输入的件数不能大于货权量')
                  this.shenQingLoading = false
                  return
                }
              }
              // let conFlag = true
              if (this.turnGoodsTableList[0].controlWeight == '1') {
                if (this.changeAllWeight > this.turnGoodsTableList[0].surplusControlWeight) {
                  this.$confirm('输入的重量大于货权量，是否继续', '提示', {
                    confirmButtonText: '继续',
                    cancelButtonText: '取消',
                    closeOnClickModal: false,
                    type: 'warning'
                  }).then(() => {
                    this.releaseFlag = 1
                    this.NiantouXiKuZHjiekou()
                  }).catch(() => {
                    this.shenQingLoading = false
                  })
                } else {
                  this.NiantouXiKuZHjiekou()
                }
              } else {
                this.NiantouXiKuZHjiekou()
              }
            }
          } else {
            this.NiantouXiKuZHjiekou()
          }
        } else {
          if (this.disShow) {
            surplusControlWeight({
              oneCustomerTaxId: this.selectionData.primaryCustomerTaxId,
              twoCustomerTaxId: this.selectionData.customerTaxId,
              organizationId: window.localStorage.getItem('tenantCode')
            })
              .then(res => {
                console.log(res)
                this.residue = res
                this.turnGoodsTableList.forEach(item => {
                  item.key = item.productTypeName + item.steelMillName + item.model + item.specification
                // item.Num = 10
                })
                let arr = sortArr(this.turnGoodsTableList, 'key')
                let infoArr = []
                arr.forEach(item => {
                  let obj = {}
                  // obj.allNumber = item.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
                  obj.productType = item[0].productType
                  obj.productTypeName = item[0].productTypeName
                  obj.steelMillName = item[0].steelMillName
                  obj.model = item[0].model
                  obj.specification = item[0].specification
                  obj.primaryCustomerTaxId = item[0].primaryCustomerTaxId
                  obj.customerTaxId = item[0].customerTaxId
                  obj.number = item.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
                  obj.customerAvailableNumber = item[0].customerAvailableNumber
                  infoArr.push(obj)
                })
                for (let i = 0; i < infoArr.length; i++) {
                  if (infoArr[i].number / 1 > infoArr[i].customerAvailableNumber) {
                    console.log(infoArr[i])
                    this.$message({
                      message: `【${infoArr[i].productTypeName}|${infoArr[i].steelMillName}|${infoArr[i].model}|${infoArr[i].specification}】总件数超过客户可提件数,请重新添加`,
                      type: 'error'
                    })
                    this.shenQingLoading = false
                    return
                  }
                }

                addEmptyChangeZy({
                // changeDetailList:this.feeList,
                  oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
                  oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
                  newPrimaryCustomerId: this.changeFrom.primaryCustomerTaxId,
                  stockCustomerId: this.selectionData.stockCustomerId,
                  newPrimaryCustomerName: this.changeFrom.newPrimaryCustomerName,
                  newSecondaryCustomerId: this.changeFrom.customerTaxId,
                  newSecondaryCustomerName: this.changeFrom.newSecondaryCustomerName,
                  oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
                  oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
                  oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
                  oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
                  randomImage: this.uploadId,
                  changeDetailList: this.turnGoodsTableList,
                  tStockSummaryList: infoArr,
                  transferExternalNo: this.transferExternalNo
                }).then((res) => {
                  this.$message.success('保存成功')
                  this.shenQingLoading = false
                  this.shenQingVisible = false
                  this.turnMark = false
                  this.turnGoodsTableList = []
                  this.uploadId = ''
                  this.changeAllWeight = 0
                  this.getSeatchData(this.searchFrom)
                }).catch((err) => {
                  this.shenQingLoading = false
                  this.$message.error(err.message)
                })
              })
          } else {
            console.log(this.turnGoodsTableList)
            this.turnGoodsTableList.forEach(item => {
              item.key = item.productTypeName + item.steelMillName + item.model + item.specification
            // item.Num = 10
            })
            let arr = sortArr(this.turnGoodsTableList, 'key')
            let infoArr = []
            arr.forEach(item => {
              let obj = {}
              // obj.allNumber = item.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
              obj.productType = item[0].productType
              obj.productTypeName = item[0].productTypeName
              obj.steelMillName = item[0].steelMillName
              obj.model = item[0].model
              obj.specification = item[0].specification
              obj.primaryCustomerTaxId = item[0].primaryCustomerTaxId
              obj.customerTaxId = item[0].customerTaxId
              obj.number = item.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
              obj.customerAvailableNumber = item[0].customerAvailableNumber
              infoArr.push(obj)
            })
            for (let i = 0; i < infoArr.length; i++) {
              if (infoArr[i].number / 1 > infoArr[i].customerAvailableNumber) {
                console.log(infoArr[i])
                this.$message({
                  message: `【${infoArr[i].productTypeName}|${infoArr[i].steelMillName}|${infoArr[i].model}|${infoArr[i].specification}】总件数超过客户可提件数,请重新添加`,
                  type: 'error'
                })
                this.shenQingLoading = false
                return
              }
            }
            addEmptyChangeZy({
              oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
              oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
              newPrimaryCustomerId: this.changeFrom.primaryCustomerTaxId,
              stockCustomerId: this.selectionData.stockCustomerId,
              newPrimaryCustomerName: this.changeFrom.newPrimaryCustomerName,
              newSecondaryCustomerId: this.changeFrom.customerTaxId,
              newSecondaryCustomerName: this.changeFrom.newSecondaryCustomerName,
              oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
              oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
              oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
              oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
              randomImage: this.uploadId,
              changeDetailList: this.turnGoodsTableList,
              tStockSummaryList: infoArr

            }).then((res) => {
              this.$message.success('保存成功')
              this.shenQingLoading = false
              this.shenQingVisible = false
              this.turnMark = false
              this.turnGoodsTableList = []
              this.uploadId = ''
              this.changeAllWeight = 0
              this.getSeatchData(this.searchFrom)
            }).catch((err) => {
              this.shenQingLoading = false
              this.$message.error(err.message)
            })
          }
        }
      }
    },
    NiantouXiKuZHjiekou () {
      this.turnGoodsTableList.forEach(item => {
        item.key = item.productTypeName + item.steelMillName + item.model + item.specification
        // item.Num = 10
      })
      let arr = sortArr(this.turnGoodsTableList, 'key')
      let infoArr = []
      arr.forEach(item => {
        let obj = {}
        // obj.allNumber = item.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
        obj.productType = item[0].productType
        obj.productTypeName = item[0].productTypeName
        obj.steelMillName = item[0].steelMillName
        obj.model = item[0].model
        obj.specification = item[0].specification
        obj.primaryCustomerTaxId = item[0].primaryCustomerTaxId
        obj.customerTaxId = item[0].customerTaxId
        obj.number = item.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
        obj.customerAvailableNumber = item[0].customerAvailableNumber
        infoArr.push(obj)
      })
      for (let i = 0; i < infoArr.length; i++) {
        if (infoArr[i].number / 1 > infoArr[i].customerAvailableNumber) {
          console.log(infoArr[i])
          this.$message({
            message: `【${infoArr[i].productTypeName}|${infoArr[i].steelMillName}|${infoArr[i].model}|${infoArr[i].specification}】总件数超过客户可提件数,请重新添加`,
            type: 'error'
          })
          this.shenQingLoading = false
          return
        }
      }
      addEmptyChangeZyKh({
        oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
        oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
        newPrimaryCustomerId: this.changeFrom.primaryCustomerTaxId,
        stockCustomerId: this.selectionData.stockCustomerId,
        newPrimaryCustomerName: this.changeFrom.newPrimaryCustomerName,
        newSecondaryCustomerId: this.changeFrom.customerTaxId,
        newSecondaryCustomerName: this.changeFrom.newSecondaryCustomerName,
        oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
        oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
        oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
        oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
        randomImage: this.uploadId,
        changeDetailList: this.turnGoodsTableList,
        tStockSummaryList: infoArr,
        cargoControlFalg: this.turnGoodsTableList[0].isEnable,
        controlWeight: this.turnGoodsTableList[0].controlWeight,
        controlPiece: this.turnGoodsTableList[0].controlPiece,
        releaseFlag: this.releaseFlag,
        transferExternalNo: this.transferExternalNo,
        pageNo: 1,
        pageSize: 50

      }).then((res) => {
        this.$message.success('保存成功')
        this.shenQingLoading = false
        this.shenQingVisible = false
        this.turnMark = false
        this.turnGoodsTableList = []
        this.uploadId = ''
        this.changeAllWeight = 0
        this.getSeatchData(this.searchFrom)
      }).catch((err) => {
        this.shenQingLoading = false
        this.$message.error(err.message)
      })
    },
    huoQuanOk () {
      this.huoQuanLoading = true
      if (this.disShow) {
        surplusControlWeight({
          oneCustomerTaxId: this.selectionData.primaryCustomerTaxId,
          twoCustomerTaxId: this.selectionData.customerTaxId,
          organizationId: window.localStorage.getItem('tenantCode')
        })
          .then(res => {
            console.log(res)
            this.residue = res
            addEmptyChangeForOwnerZy({
              oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
              oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
              newPrimaryCustomerId: this.huoQuanFrom.primaryCustomerTaxId,
              ownerCustomerTaxId: this.huoQuanFrom.ownerCustomerTaxId,
              newPrimaryCustomerName: this.huoQuanFrom.primaryCustomerName,
              newSecondaryCustomerId: this.huoQuanFrom.customerTaxId,
              newSecondaryCustomerName: this.huoQuanFrom.customerName,
              oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
              oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
              oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
              oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
              randomImage: this.uploadId,
              changeDetailList: this.turnGoodsTableList
            }).then((res) => {
              this.$message.success('保存成功')
              this.huoQuanLoading = false
              this.huoQuanVisible = false
              this.turnMark = false
              this.turnGoodsTableList = []
              this.uploadId = ''
              this.changeAllWeight = 0
              this.getSeatchData(this.searchFrom)
            }).catch((err) => {
              this.huoQuanLoading = false
              this.$message.error(err.message)
            })
          })
      } else {
        addEmptyChangeForOwnerZy({
          oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
          oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
          ownerCustomerTaxId: this.huoQuanFrom.ownerCustomerTaxId,
          newPrimaryCustomerId: this.huoQuanFrom.primaryCustomerTaxId,
          newPrimaryCustomerName: this.huoQuanFrom.primaryCustomerName,
          newSecondaryCustomerId: this.huoQuanFrom.customerTaxId,
          newSecondaryCustomerName: this.huoQuanFrom.customerName,
          oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
          oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
          oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
          oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
          randomImage: this.uploadId,
          changeDetailList: this.turnGoodsTableList
        }).then((res) => {
          this.$message.success('保存成功')
          this.huoQuanLoading = false
          this.huoQuanVisible = false
          this.turnMark = false
          this.turnGoodsTableList = []
          this.uploadId = ''
          this.changeAllWeight = 0
          this.getSeatchData(this.searchFrom)
        }).catch((err) => {
          this.huoQuanLoading = false
          this.$message.error(err.message)
        })
      }
    },
    //  转给货权方
    zhuanHQClick () {
      if (this.turnGoodsTableList.length == 0) {
        DonMessage.error('请点击预转添加转货清单')
      } else {
        // 对多项转货进行校验，转货件数不能为空，转货件数不能超过库存可转件数 1为转货件数为空，2为转货件数大于库存可转件数
        let finished = 0
        this.turnGoodsTableList.forEach(item => {
          if (item.changeNumber == undefined || item.changeNumber == null || item.changeNumber == '') {
            finished = 1
          } else if (item.changeNumber > item.stockAvailableNumber) {
            finished = 2
          }
        })
        if (finished == 1) {
          this.$message.error('请输入转货件数')
          return
        } else if (finished == 2) {
          this.$message({
            message: '转货件数不能大于库存可转件数',
            type: 'error'
          })
          return
        }
        // 转货件数大于库存可转件数
        if (this.BigNmuber == 1) {
          this.$message.error('转货件数不能大于库存可转件数')
        } else {
          // 对于控货类型的，需要进行计算，转货总重量不能大于控货剩余量
          if (this.disShow && this.changeAllWeight > this.residue) {
            this.$message.error('转货总重量不能大于控货剩余量')
          } else {
            this.zhuanHQVisible = true
          }
        }
        // 对于控货类型的，需要进行计算，转货总重量不能大于控货剩余量
        // if (this.disShow && this.changeAllWeight > this.residue) {
        //   this.$message.error('转货总重量不能大于控货剩余量')
        // }
        // this.zhuanHQVisible = true
        this.zhuanHQFrom.primaryCustomerTaxId = this.turnGoodsTableList[0].primaryCustomerTaxId
        this.zhuanHQFrom.customerTaxId = this.turnGoodsTableList[0].customerTaxId
        this.zhuanHQFrom.primaryCustomerName = this.turnGoodsTableList[0].primaryCustomerName
        this.zhuanHQFrom.customerName = this.turnGoodsTableList[0].customerName
      }
    },
    // 转给货权方取消
    zhuanHQQuXiao (formName) {
      this.zhuanHQVisible = false
      this.zhuanHQLoading = false
      this.$refs[formName].resetFields()
    },
    zhuanHQOk () {
      this.$refs.zhuanHQFrom.validate((valid) => {
        if (valid) {
          this.zhuanHQLoading = true
          this.zhuanHQFrom.newOwnerCustomerName = ''
          this.customerData.forEach((item) => {
            if (this.zhuanHQFrom.newOwnerCustomerTaxId == item.taxpayerNumber) {
              this.zhuanHQFrom.newOwnerCustomerName = item.custerName
            }
          })
          if (this.disShow) {
            surplusControlWeight({
              oneCustomerTaxId: this.selectionData.primaryCustomerTaxId,
              twoCustomerTaxId: this.selectionData.customerTaxId,
              organizationId: window.localStorage.getItem('tenantCode')
            })
              .then(res => {
                console.log(res)
                this.residue = res
                addEmptyChangeToOwner({
                  newOwnerCustomerName: this.zhuanHQFrom.newOwnerCustomerName, // 原货权方名称
                  newOwnerCustomerTaxId: this.zhuanHQFrom.newOwnerCustomerTaxId, // 原货权方纳税人
                  newPrimaryCustomerId: this.zhuanHQFrom.primaryCustomerTaxId,
                  newPrimaryCustomerName: this.zhuanHQFrom.primaryCustomerName,
                  newSecondaryCustomerId: this.zhuanHQFrom.customerTaxId,
                  newSecondaryCustomerName: this.zhuanHQFrom.customerName,
                  oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
                  oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
                  oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
                  oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
                  changeDetailList: this.turnGoodsTableList
                }).then((res) => {
                  this.$message.success('保存成功')
                  this.zhuanHQLoading = false
                  this.zhuanHQVisible = false
                  this.turnMark = false
                  this.$set(this, 'zhuanHQFrom', {})
                  this.turnGoodsTableList = []
                  this.changeAllWeight = 0
                  this.getSeatchData(this.searchFrom)
                }).catch((err) => {
                  this.zhuanHQLoading = false
                  this.$message.error(err.message)
                })
              })
          } else {
            addEmptyChangeToOwner({
              newOwnerCustomerName: this.zhuanHQFrom.newOwnerCustomerName, // 原货权方名称
              newOwnerCustomerTaxId: this.zhuanHQFrom.newOwnerCustomerTaxId, // 原货权方纳税人
              newPrimaryCustomerId: this.zhuanHQFrom.primaryCustomerTaxId,
              newPrimaryCustomerName: this.zhuanHQFrom.primaryCustomerName,
              newSecondaryCustomerId: this.zhuanHQFrom.customerTaxId,
              newSecondaryCustomerName: this.zhuanHQFrom.customerName,
              oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
              oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
              oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
              oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
              changeDetailList: this.turnGoodsTableList
            }).then((res) => {
              this.$message.success('保存成功')
              this.zhuanHQLoading = false
              this.zhuanHQVisible = false
              this.turnMark = false
              this.$set(this, 'zhuanHQFrom', {})
              this.turnGoodsTableList = []
              this.changeAllWeight = 0
              this.getSeatchData(this.searchFrom)
            }).catch((err) => {
              this.zhuanHQLoading = false
              this.$message.error(err.message)
            })
          }
        } else {
          this.zhuanHQLoading = false
          return false
        }
      })
    }
  }
}

</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}

.searchBox {
  margin-left: 25px;
}

.inpBox {
  margin: 5px 0 0 -30px;
}

/deep/.inpBox .el-input__inner {
  width: 170px;
}

.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}

.tongJi {
  display: flex;
  margin-left: 10px;
}

.tongJi_item {
  margin-right: 20px;
}

.tongJi_item span {
  color: red;
}

.addstyle {
  margin-left: 94%;
}

.addMarkBox {
  .addMarkBox-title {
    width: 150px;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
  }

  .addMarkBox-content {
    width: 45%;
    margin: 30px auto;

    div {
      padding-bottom: 5px;
      font-weight: 700;

      .ipt {
        width: 150px;
      }
    }
  }
}

.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;

  img {
    height: calc(100vh - 250px);
    // background-size: 100% 100%;
  }
}

//查看凭证弹窗 -放大
.oneTwo {
  z-index: 11111 !important;
}

.img_box {

  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // flex-wrap: wrap;
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    // border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;

    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}

.numbers {
  margin-left: 10px;
  margin-right: 10px;
  color: red;
}

.box1 {
  overflow: hidden;
}

.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
  // height:150px;
  // background-color:red;
  // .imgbox{
  //   border-bottom: 1px solid #ccc;
  // }

}

.rightbox {
  margin-left: 50px;
  width: 850px;
  float: left;

  // height:150px;
  // background-color:yellow;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
